import ptLibrary from '@/language/pt/library';

// Reverse map: Portuguese originalTitle → library card ID
const originalTitleToLibraryId = Object.entries(ptLibrary).reduce((acc, [id, { title }]) => {
  if (title) acc[title] = id;
  return acc;
}, {});

/**
 * Returns the translated card title for the active locale.
 * Only translates when the user has not explicitly customized the title
 * (detected via the card.props.titleCustomized flag, set on explicit save).
 * Falls back to card.props.title when no translation is found.
 *
 * @param {Object} card - The card object from the dashboard store
 * @param {Object} i18n - The Vue i18n instance (this.$t / this.$te)
 * @returns {string}
 */
export function resolveCardTitle(card, i18n) {
  const { title, originalTitle, titleCustomized } = card.props;

  // User has explicitly customized the title — never auto-translate
  if (titleCustomized) return title;

  const libraryId = originalTitleToLibraryId[originalTitle];
  if (!libraryId) return title;

  const key = `library.${libraryId}.title`;
  return i18n.$te(key) ? i18n.$t(key) : title;
}
